<div fxLayout="column"
     fxLayoutAlign="space-between center"
     fxLayoutGap="30px"
     class="body-1-default info-panel p-3 pe-3"
     [class]="panelClass"
     [class.info-panel-full-width]="fullWidth"
     [class.body-1-regular-1]="type === PanelType.DISABLED"
     [class.info-panel-disabled]="type === PanelType.DISABLED">

  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" [class.info-panel-full-width]="fullWidth">
    <mat-icon [ngClass]="[getPanelType().iconClass, iconClass].filter(Boolean)"
              fxFlexAlign="start">
      {{getPanelType().icon}}
    </mat-icon>
    <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
      <ng-content></ng-content>
    </div>
  </div>

  <div class="full-width"
       fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
    <button mat-flat-button
            class="link-text btn-cursor button-action-cancel"
            (click)="toggleExpanded()">
      {{ isExpanded ? 'Read less' : 'Read more...' }}
    </button>
    <div *ngIf="showButtons" class="fx-row fx-gap-10">
      @for (button of buttonLabels; track button; let i = $index) {
        <button class="button-action" mat-flat-button
                [disabled]="buttonDisabled![i]"
                (click)="emit(i)">
          <div class="button-text">{{ button! }}</div>
        </button>
      }
      </div>
  </div>
</div>
